import { isPlatformBrowser } from '@angular/common';
import { Component, DestroyRef, inject, Inject, input, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import moment from 'moment';
import { MediaService } from '@app/services/media.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'clever-flugfilter',
    templateUrl: './flugfilter.component.html',
    styleUrls: ['./flugfilter.component.scss'],
    standalone: false
})
export class FlugfilterComponent implements OnInit {
    mode = input<string>('');
    israiltravel = input<boolean>(false);
    type = input<string>('');
    reference = input<string>('');
    realparams = input<ParamFilters>(null);

    isBrowser = signal<boolean>(false);
    showMore = signal<boolean>(false);
    smallVersion = signal<boolean>(true);

    btntext = signal<string>('Flug finden');
    start = signal<string>('');
    end = signal<string>('');
    filter = signal<ParamFilters>(null);

    destroyRef = inject(DestroyRef);

    local_type = signal<string>('');

    constructor(
        protected mediaService: MediaService,
        protected hotelFilters: HotelFiltersService,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        this.local_type.set(this.type());
        this.initFilterSub();
        this.initFilters();
    }

    gotoZiel(): void {
        this.smallVersion.set(true);
        this.hotelFilters.setReference(this.reference());
        this.hotelFilters.gotoUrlFlug(this.type());
    }

    showMBMenu(): void {
        this.smallVersion.set(false);
    }

    openclosemore(): void {
        this.showMore.set(!this.showMore());
        if (!this.showMore) {
            // window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    initFilters(): void {
        if (this.realparams()) {
            this.hotelFilters.onlySetRealParams(this.realparams());
        } else if (this.mode() === 'home') {
            this.hotelFilters.resetAllExtrasHome();
        }
    }

    switchType(type): void {
        this.local_type.set(type);
        this.hotelFilters.onlySetProductType(this.local_type());
    }

    initFilterSub(): void {
        this.hotelFilters.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((filter: ParamFilters) => {
            if (filter) {
                this.filter.set(JSON.parse(JSON.stringify(filter)));
                this.local_type.set(this.filter()?.productType);
                this.initDate(filter);
            }
        });
    }

    async initDate(filter) {
        const reg = new RegExp('^\\d+,\\d+,\\d+$');
        if (String(filter?.reisezeitraumResult).match(reg)) {
            const tmp = String(filter?.reisezeitraumResult).split(',');
            this.start.set(moment().add(tmp[0], 'days').format('YYYY-MM-DD'));
            this.end.set(moment().add(Number(tmp[1]) + Number(tmp[0]), 'days').format('YYYY-MM-DD'));
        } else if (filter?.reisezeitraumResult?.start?.length > 0) {
            this.start.set(moment(filter.reisezeitraumResult.start).format('YYYY-MM-DD'));
            this.end.set(moment(filter.reisezeitraumResult.end).format('YYYY-MM-DD'));
        } else if (!isNaN(Number(filter?.reisezeitraumResult?.start))) {
            this.start.set(moment().add(Number(filter.reisezeitraumResult.start), 'days').format('YYYY-MM-DD'));
            this.end.set(moment().add(Number(filter.reisezeitraumResult.end), 'days').format('YYYY-MM-DD'));
        } else {
            this.start.set(moment().add(4, 'days').format('YYYY-MM-DD'));
            this.end.set(moment().add(180, 'days').format('YYYY-MM-DD'));
        }
    }

    async selectValue(ev) {
        this.hotelFilters.reisezeitraumResult(ev.start, ev.end);
    }

    async resTraveler(ev) {
        this.hotelFilters.reisendeResult(ev);
    }
}
